const t = {
  name: "DebitCard",
  dimensions: { width: 24, height: 17 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10">
      <path d="M21 15.75H3C1.9 15.75 1 14.85 1 13.75V3.75C1 2.65 1.9 1.75 3 1.75H21C22.1 1.75 23 2.65 23 3.75V13.75C23 14.85 22.1 15.75 21 15.75Z"/>
      <path d="M5 11.75H11" stroke-linecap="round"/>
      <path d="M15 5.75L19 5.75" stroke-linecap="round"/>
    </g>
  `
};
export {
  t as DebitCard
};
